/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDistributionsAnalysis = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2v20h20v-2H4V2zm8 12.5c-1.5 3-4 3.5-4 3.5h16s-2 0-4-3.5a63.516 63.516 0 0 1-1.31-2.438C15.667 10.088 15.105 9 14 9c-1.306 0-2.233 1.896-3.442 4.367-.179.366-.364.745-.558 1.133z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDistributionsAnalysis as DistributionsAnalysis };
